/* v8 ignore start -- @preserve */

export const DEFAULT_PHONE_CODE = {
  icon: "/images/flags/gb.svg",
  inputLabel: "+44",
  label: "+44 - United Kingdom",
  regionCode: "GB",
  value: "+44",
} as const;

export const MSW_BASE_URL = "http://localhost:9090/";

export const TEST_DOMAIN = "http://localhost";

export const DEFAULT_THEME = "light";
export const MAX_FILE_SIZE = 25 * 1024 * 1024;

export const MAX_EMAIL_ATTACHMENTS = 10;

export const DEFAULT_LOGO = "/images/vega.svg";
export const DEFAULT_LOGO_LIGHT = "/images/vega_black.svg";

export const DEFAULT_LOGO_SMALL = "/images/vega-logo-light.svg";
export const LIMIT_PER_PAGE = 50;

export const VEGA_ID = "11111111-1111-1111-1111-111111111111";

export const DEFAULT_MONEY_LOCALE = "en-US";

export const UK = "eef90ee1-48cd-4584-95f2-16a909da9d33";

export const SERVER_DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";

export enum Key {
  Escape = "Escape",
  Enter = "Enter",
  Space = " ",
  ArrowUp = "ArrowUp",
  ArrowDown = "ArrowDown",
  K = "k",
}

export const KEY_DISPLAY = {
  arrows: "↑↓",
  enter: "↵",
  escape: "Esc",
} as const;

export const DEFAULT_SUPPORT_EMAIL =
  "hello@vega.investments?subject=Support%20Request";
export const ISA_SUPPORT_EMAIL = "isaccounts@vega.investments";

export const DEFAULT_PRIMARY_COLOR = "#62C9D0";
export const DEFAULT_PRIMARY_COLOR_10 = "rgba(98, 201, 208, 0.1)";
export const DEFAULT_PRIMARY_COLOR_30 = "rgba(98, 201, 208, 0.1)";
export const DEFAULT_PRIMARY_COLOR_50 = "rgba(98, 201, 208, 0.1)";
export const DEFAULT_HOVER_COLOR = "#4FA3A8";
export const DEFAULT_OPACITY_COLOR = "#62C9D033";
export const DEFAULT_ACTIVE_COLOR = "#3D7E82";
export const DEFAULT_PURPLE_COLOR = "#B362D0";
export const DEFAULT_DARK_GRAY_700 = "#3C434B";

export const ASSET_LOGO_PLACEHOLDER = "/images/5_logo_public_markets.png";

export const DEFAULT_LOCALE = "en-GB";
export const HASH_PLACEHOLDER = "###";
export const XXX_PLACEHOLDER = "XXXXXXX";

export const VERIFICATION_CODE_LENGTH = 4;
export const OTP_RESEND_INTERVAL = 15000;

/** UTF-8 BOM (`U+FEFF`); prepend to CSV so Excel on Windows detects UTF-8. */
export const UTF_8_BYTE_ORDER_MARK = "\uFEFF";

export const EMPTY_CELL_VALUE = "—";
